import React, { useState } from "react";
import { fmt } from "../constants";
import StatusBadge from "./StatusBadge";

export default function LinhaOS({o, onEditar, onExcluir, onMudarStatus}){
  const [open,setOpen]=useState(false);
  return(
    <React.Fragment>
      <tr className="tr-expandable" onClick={()=>setOpen(v=>!v)}>
        <td className="td-mono">#{o.id}</td>
        <td><strong>{o.cliente_nome}</strong></td>
        <td><span style={{fontSize:11,padding:"2px 8px",borderRadius:4,background:o.tipo_cliente==="ARQ_ENG"?"#f0f4ff":"#f0fdf4",color:o.tipo_cliente==="ARQ_ENG"?"var(--z-blue)":"#16a34a"}}>{o.tipo_cliente==="ARQ_ENG"?"Arq/Eng":"Consumidor"}</span></td>
        <td className="fs-12 text-secondary">{o.tecnico_nome||"—"}</td>
        <td className="fs-12 text-secondary">{o.data_agendada?new Date(o.data_agendada).toLocaleString("pt-BR",{dateStyle:"short",timeStyle:"short"}):"—"}</td>
        <td className="td-r fw-600">R$ {fmt(o.valor_total)}</td>
        <td><StatusBadge status={o.status}/></td>
        <td className="td-r"><i className={"ti ti-chevron-"+(open?"up":"down")} style={{fontSize:14,color:"var(--z-text-muted)"}}/></td>
      </tr>
      {open&&(
        <tr className="tr-dropdown"><td colSpan={8}>
          <div className="dropdown-content">
            {o.endereco&&<div className="fs-13 mb-8"><i className="ti ti-map-pin"/> {o.endereco}{o.cidade&&`, ${o.cidade}/${o.estado}`}</div>}
            {o.descricao&&<div className="fs-13 mb-8 text-secondary">{o.descricao}</div>}
            {(o.itens||[]).length>0&&(
              <table style={{width:"100%",fontSize:12,marginBottom:12}}>
                <thead><tr className="bg-page"><th className="td-l">Produto</th><th className="td-r">Qtd</th><th className="td-r">Unit</th><th className="td-r">Total</th></tr></thead>
                <tbody>{o.itens.map(it=>(
                  <tr key={it.id} style={{borderBottom:"1px solid var(--z-border)"}}>
                    <td className="td-p">{it.produto_codigo} — {it.produto_nome}</td>
                    <td className="td-r">{fmt(it.quantidade)}</td>
                    <td className="td-r">R$ {fmt(it.valor_unit)}</td>
                    <td className="td-r fw-600">R$ {fmt(it.valor_total)}</td>
                  </tr>
                ))}</tbody>
              </table>
            )}
            <div className="flex-row mb-12 fs-13">
              <span>MO: <strong>R$ {fmt(o.valor_mo)}</strong></span>
              <span>Materiais: <strong>R$ {fmt(o.valor_materiais)}</strong></span>
              <span>Total: <strong className="text-blue">R$ {fmt(o.valor_total)}</strong></span>
            </div>
            {o.observacoes&&<div className="fs-12 text-secondary mb-8">Obs: {o.observacoes}</div>}
            <div className="produto-dropdown-acoes">
              <button className="btn btn-secondary fs-12" onClick={e=>{e.stopPropagation();onEditar(o);}}>
                <i className="ti ti-edit"/> Editar
              </button>
              <button className="btn btn-danger fs-12" onClick={e=>{e.stopPropagation();onExcluir(o.id);}}>
                <i className="ti ti-trash"/> Excluir
              </button>
              {o.status==="AGENDADO"&&<button className="btn btn-primary fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"EM_EXECUCAO");}}>Iniciar Execucao</button>}
              {o.status==="EM_EXECUCAO"&&<button className="btn btn-primary fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"CONCLUIDO");}}>Concluir OS</button>}
              {!["CANCELADO","CONCLUIDO"].includes(o.status)&&<button className="btn btn-danger fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"CANCELADO");}}>Cancelar</button>}
            </div>
          </div>
        </td></tr>
      )}
    </React.Fragment>
  );
}
